import * as React from 'react';
import { bindActionCreators } from 'redux';
import { menuMainLoad } from 'moduleBase/modules/menu/actions/main-load';
import { REDUCER_MENU_NAME } from 'moduleBase/modules/menu/constants';
import { MenuPanelTabs } from 'moduleBase/modules/menu/components/mobile/MenuPanelTabs';
import { MenuPanelBottom } from 'moduleBase/modules/menu/components/mobile/MenuPanelBottom';
import { connect } from '@collaborator/npm_modules/dist/components/redux';

var MobileNav = function MobileNav(_ref) {
  var hide = _ref.hide,
      menu = _ref.menu;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuPanelTabs, {
    menu: menu,
    hide: hide
  }), /*#__PURE__*/React.createElement(MenuPanelBottom, {
    menu: menu,
    hide: hide
  }));
};

export default connect(MobileNav, {
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_MENU_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      load: menuMainLoad
    }, dispatch);
  }
});